import RendererRegistry from '@opsbase/web-data-renderer/RendererRegistry';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import React, { useMemo } from 'react';
import useReportCSS from '../useReportCSS';
export function ViewReportDataTableCell(props) {
    const { item, field, colIdx = 0, rowIdx = 0, colSpan = 1, rowSpan = 1, inlineTitles = false, } = props;
    const myCss = useReportCSS(true);
    const renderer = useMemo(() => RendererRegistry.get(field, colIdx, true), [field, colIdx]);
    return (React.createElement("td", { colSpan: colSpan, rowSpan: rowSpan, key: item.id + '.' + field.key + '.' + field.propertyName, className: myCss.data },
        inlineTitles && (React.createElement(Vertical, { divider: true, style: { minHeight: 70 } },
            React.createElement(Pane, { shrink: true, classes: { root: myCss.inlineheading } }, field.label),
            React.createElement(Pane, { grow: true, style: { position: 'unset' } }, renderer(item, rowIdx)))),
        !inlineTitles && renderer(item, rowIdx)));
}
export default ViewReportDataTableCell;
